import { NgModule } from '@angular/core';
import { BookingLinkPageComponent } from './booking-link-page.component';
import { UpdateBookingLinkConfirmationDialogComponent } from './update-booking-link-confirmation-dialog/update-booking-link-confirmation-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CommonModule } from '@angular/common';

import { NavigationModule } from '../sales-center-navigation/navigation.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MeetingSchedulerSharedModule } from '../shared/meeting-scheduler-shared.module';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyStickyFooterModule } from '@vendasta/galaxy/sticky-footer';
import { MeetingSchedulerSettingsModule } from '../schedule-settings/schedule-settings.module';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MatChipInput, MatChipRow, MatChipsModule } from '@angular/material/chips';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';


@NgModule({
  declarations: [BookingLinkPageComponent, UpdateBookingLinkConfirmationDialogComponent],
  imports: [
    TranslateModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatExpansionModule,
    MatDialogModule,
    DragDropModule,
    GalaxyAlertModule,
    MatCardModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    MeetingSchedulerSharedModule,
    NavigationModule,
    CommonModule,
    MatSlideToggleModule,
    NavigationModule,
    MatProgressSpinnerModule,
    GalaxyFormFieldModule,
    GalaxyStickyFooterModule,
    MeetingSchedulerSettingsModule,
    MatRadioGroup,
    MatRadioButton,
    MatChipInput,
    MatAutocompleteTrigger,
    MatAutocomplete,
    MatChipRow,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  providers: [],
})
export class BookingLinkModule {}
